import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddCinevillePassModel, CinevillePassModel } from '@digilize/shared/definitions/src';

@Injectable({
  providedIn: 'root',
})
export class CinevilleApiService {
  private readonly baseUrl = '/api/v1.0/cineville';

  constructor(private http: HttpClient) {}

  /**
   * Validates a Cineville reservation.
   * @param payload The reservation data to validate.
   */
  validateReservation(payload: ValidateCinevilleReservationModel) {
    return this.http.post(`${this.baseUrl}/validate-reservation`, payload);
  }

  /**
   * Cancels one or more Cineville reservations by order-line ID.
   * The ids go in the body — there is no per-id route.
   * @param orderLineIds The order-line IDs to cancel.
   */
  cancelReservation(orderLineIds: string[]) {
    return this.http.post<void>(`${this.baseUrl}/reservation/cancel`, { order_line_ids: orderLineIds });
  }

  /**
   * Retrieves user Cineville passes.
   */
  getUserPasses() {
    return this.http.get<CinevillePassModel[]>(`${this.baseUrl}/user-passes`);
  }

  /**
   * Adds a user Cineville pass.
   * @param payload The pass data to add.
   */
  addUserPass(payload: AddCinevillePassModel) {
    return this.http.post<CinevillePassModel>(`${this.baseUrl}/user-passes`, payload);
  }

  /**
   * Deletes a user Cineville pass by ID.
   * @param passId The pass ID to delete.
   */
  deleteUserPass(passId: string) {
    return this.http.delete(`${this.baseUrl}/user-passes/${passId}`);
  }
}

export interface ValidateCinevilleReservationModel {
  barcode: string;
  show_id: string;
}
